import ReturnCom from "@/components/ReturnCom"
import titleImg from '@/image/titleImg.svg'
import { Tooltip } from "antd"
import d1 from '@/image/d1.svg'
import d2 from '@/image/d2.svg'
import d3 from '@/image/d3.svg'
import d4 from '@/image/d4.svg'
import d5 from '@/image/d5.svg'
import d6 from '@/image/d6.svg'
import d11 from '@/image/d11.svg'
import d22 from '@/image/d22.svg'
import d33 from '@/image/d33.svg'
import d44 from '@/image/d44.svg'
import d55 from '@/image/d55.svg'
import d66 from '@/image/d66.svg'
import useGetUserInfo from "@/web3Hook/useGetUserInfo"
import { formatUnits } from "ethers"
import { LoadingOutlined } from "@ant-design/icons"
import BalanceCom from "@/components/BalanceCom"
import { useTranslation } from "react-i18next"

const data = [
    { img: d1, bg: d11 },
    { img: d2, bg: d22 },
    { img: d3, bg: d33 },
    { img: d4, bg: d44 },
    { img: d5, bg: d55 },
    { img: d6, bg: d66 },
]
const Grade = () => {
    const { t } = useTranslation()
    const { userInfo, userInfoLod } = useGetUserInfo()

    return (
        <div className="px-4 mt-3.5 md:max-w-[750px] md:mx-auto md:mt-6">
            <div className="mb-8 md:mb-10 flex items-center">
                <ReturnCom title={t('grade.currentLevel')} />
                <Tooltip color="#FFFFFF" placement="rightTop" title={
                    <div>
                        {data.map((item, index) => (
                            <div key={index} className="flex items-center mb-2 last:mb-0">
                                <img src={item.img} alt="" className="w-6 h-6 md:w-7 md:h-7 mr-2" />
                                <span className="text-sm md:text-base">{t('grade.level')} {index}</span>
                            </div>
                        ))}
                    </div>
                } >
                    <img src={titleImg} className="w-6 h-6 md:w-7 md:h-7 cursor-pointer hover:opacity-80 transition-opacity" alt="" />
                </Tooltip>
            </div>
            <div className="bg3 w-83.75 md:w-full md:max-w-[450px] h-38.25 md:h-[205px] mx-auto text-cf pl-8.75 md:pl-12 flex justify-between">
                <div>
                    <div className="flex pt-8.75 md:pt-12 mb-7 md:mb-8">
                        <span className="mr-2 text-sm md:text-base">{t('grade.currentLevel')}</span>
                        {
                            userInfoLod ?
                                <LoadingOutlined className="text-base md:text-lg" />
                                : <>
                                    <img className="mr-1 w-5 h-5 md:w-6 md:h-6" src={data[Number(formatUnits(userInfo?.curLevel, 0))].img} alt="" />
                                    <span className="text-sm md:text-base">G{Number(formatUnits(userInfo?.curLevel, 0))}</span>
                                </>
                        }

                    </div>
                    <BalanceCom qText={`${t('grade.historicalHighestLevel')}: G`} balance={userInfo.bestLevel} unit={0} loading={userInfoLod} />
                </div>
                {/* <div className="relative -left-7 md:-left-10 -top-2 md:-top-3">
                    {
                        !userInfoLod &&
                        <img className="w-24 md:w-32" src={data[Number(formatUnits(userInfo?.curLevel, 0))].bg} alt="" />

                    }
                </div> */}
            </div>
        </div >
    )
}

export default Grade